import React from 'react';
import { Box } from '@mui/material';
import { GREEN_DARK, GREEN_SOFT, MUTED } from '../home/homeTheme';

/** Stato del progetto: verde se attivo, grigio se inattivo. */
export default function StatusChip({ active }) {
  return (
    <Box component="span" sx={{ px: 0.9, py: 0.2, borderRadius: 999, fontSize: 11.5, fontWeight: 700, whiteSpace: 'nowrap', bgcolor: active ? GREEN_SOFT : 'var(--rt-track)', color: active ? GREEN_DARK : MUTED }}>
      {active ? 'Active' : 'Inactive'}
    </Box>
  );
}
